import { EmploymentDetailsNew_MX } from './mixed';

export const EmploymentDetailsFormNew = {
  /**
   * PrivateLease
   */
  PL: EmploymentDetailsNew_MX,
};
